import { Component } from '@angular/core';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-divider-wide',
    templateUrl: './toolbar-button-divider-wide.component.html',
    styleUrl: './toolbar-button-divider-wide.component.scss',
    imports: [MatDivider]
})
export class ToolbarButtonDividerWideComponent {}
